import type { Analytics, AnalyticsEvent, AnalyticsPayload } from "./Analytics";

export type PostHogLike = { capture(event: string, properties: AnalyticsPayload): void };

export class PostHogAdapter implements Analytics {
  constructor(
    private readonly client: PostHogLike,
    private readonly playerId: string,
    private readonly sessionId: string,
  ) {}

  track(event: AnalyticsEvent, properties: Record<string, string | number | boolean> = {}): void {
    this.client.capture(event, {
      playerId: this.playerId, sessionId: this.sessionId,
      timestamp: new Date().toISOString(), ...properties,
    });
  }
}
